import eddConfiguration from './eddConfiguration'
export default {
  'plugin/eddConfiguration': eddConfiguration,
}
